
// Utils

import { transformDropdownOptionsToObject } from '../normalize/transformDropdownOptionsToObject';

// Constants

import { FREQUENCY_TYPES } from '@constants/ssap/hhmTypes/frequencyTypes';
import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';

// Defensive: UNSPECIFIED and unknown codes are not valid business cases for user-selected frequency.
// The stable message id avoids formatMessage crashes when payloads are malformed or legacy.
const FREQUENCY_UNSPECIFIED_MESSAGE_ID = 'ssap.input.unspecified';

export const getFrequencyId = (frequency, shouldNotProcess = undefined) => {
    const FREQUENCIES_LIST = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.FREQUENCY);

    if (frequency === FREQUENCY_TYPES.UNSPECIFIED) {
        return FREQUENCY_UNSPECIFIED_MESSAGE_ID;
    }

    if(shouldNotProcess) {
        return FREQUENCIES_LIST[frequency] || FREQUENCY_UNSPECIFIED_MESSAGE_ID;
    }

    switch(frequency) {
        case FREQUENCY_TYPES.DAILY:
            return 'common.day_frequency_and_cycles';
        case FREQUENCY_TYPES.HOURLY:
            return 'common.hour_frequency_and_cycles';
        default:
            return FREQUENCIES_LIST[frequency] || FREQUENCY_UNSPECIFIED_MESSAGE_ID;
    }
};